import angular from 'angular';
import detailZoneComponent from './detail-zone.component';
import DetailZoneService from './detail-zone.service';
import detailZoneConfig from './detail-zone.config';

let detailZoneModule = angular.module('app.payZone.detailZone',[])
  .component('detailZone', detailZoneComponent)
  .service('DetailZoneService', DetailZoneService)
  .config(detailZoneConfig);

export default detailZoneModule;



// WEBPACK FOOTER //
// ./www/components/pay-zone/detail-zone/detail-zone.js